export const calculateColumnEarnings = (deals: any[]): number => {
  if (!deals || deals.length === 0) return 0;

  const sum = deals.reduce((total, deal) => {
    const amount = deal.amount || 0;
    const numericAmount = typeof amount === 'number' ? amount : parseFloat(String(amount)) || 0;
    return total + numericAmount;
  }, 0);

  return Math.round(sum * 10) / 10;
};
